module.exports = __webpack_public_path__ + "fonts/Roboto-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Light.ttf
// module id = 266
// module chunks = 0